import { render, staticRenderFns } from "./OdinPlatform.vue?vue&type=template&id=c8f0163e"
import script from "./OdinPlatform.vue?vue&type=script&lang=js"
export * from "./OdinPlatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports